import React from "react";
import OpenOrders from "./OpenOrders";

/**
 * Futures perpetual open orders — same layout/data as generic Open Orders (`OpenOrders`),
 * shared `spotOrders.css` (loaded globally from App.js).
 */
export default function FuturesOpenOrders(props) {
  return <OpenOrders {...props} pageTitle="Futures Open Order" idPrefix="fo" />;
}

